<template>
    <div class="abgne_tab filter_tab">
        <div class="row filter_word">
            <h1 class="Headline">{{content[prefix+'_nickname']}}</h1>
            <div class="container breadcrumbWrapper">
                <div class="row">
                    <div class="col-xs-12 col-sm-8">
                        <ol class="breadcrumb">
                            <li class="breadcrumb-item">
                                <a :href="get_host">首頁</a>
                            </li>
                            <li class="breadcrumb-item">
                                <a :href="`${get_host}articles/main`">保險文章</a>
                            </li>
                            <li class="breadcrumb-item">
                                <a :href="`${get_host}articles/All`">所有文章</a>
                            </li>
                            <li class="breadcrumb-item">
                                {{nav_name}}
                            </li>
                            <li class="breadcrumb-item active">
                                {{content[prefix+'_nickname']}}
                            </li>
                        </ol>
                    </div>
                    <div class="col-xs-12 col-sm-4 eye">
                        <div class="moreInfo">
                            <i class="fas fa-book">
                            </i>&nbsp;共&nbsp;{{qty}}&nbsp;篇&nbsp;&nbsp;
                            <i class="fas fa-eye">
                            </i>&nbsp;{{count_up}}&nbsp;次&nbsp;&nbsp;
                        </div>
                    </div>
                </div>
            </div>
            <ul class="tabs filter_tabs">
                <li>最新文章</li>
                <li>熱門文章</li>
            </ul>
        </div>
        <div class="tab_container">
            <list id="tab2" list-field="latest_list"></list>
            <list id="tab1" list-field="hot_list"></list>
        </div>
    </div>
</template>

<script>

    import List from "../components/List";
    export default {
        name: "Page",
        components: {List},
        computed:{
            qty(){
                const self = this;
                return self.$store.state.qty;
            },
            count_up(){
                const self = this;
                return self.$store.state.count_up;
            },
            get_host(){
                const self = this;
                return self.$store.state.get_host;
            },
            nav_name(){
                const self = this;
                return self.$store.state.nav_name;
            },
            prefix(){
                const self = this;
                return self.$store.state.prefix;
            },
            content(){
                const self = this;

                return self.$store.state.content;
            }
        }

    }
</script>

<style scoped>

</style>